// extracted by mini-css-extract-plugin
export var legendIndicator = "_gf-1";
export var legendRight = "_gf-0";